<template>
  <div id="newsListBox" class="box_n">
    <div class="team-box wow bounceInRight animated" style="margin-bottom:150px">
      <div class="team-item"
       v-for="item of chList" :key="item.id"
       @click="getUserInfo(item.id)"
      >
         <div class="team-left">
            <div class="p1">
              <!-- <span>刘 道臣</span> -->
              <span v-if="lange=='ch'">{{item.cnName?item.cnName.substring(0,1)+' '+item.cnName.substring(1):''}}</span>
              <span v-if="lange=='en'">{{item.enName}}</span>
            </div>
            <!-- <div class="p2">主任 / 创始合伙人</div> -->
            <div class="p2"  v-if="lange=='ch'">{{item.cnDuties}}</div>
            <div class="p2"  v-if="lange=='en'">{{item.enDuties}}</div>
            <div class="team-phone">
               <div>
                 <img src="../../../assets/images/phone.png" alt="">
                 {{item.phoneNum}}
               </div>
               <div>
                 <img src="../../../assets/images/web.png" alt="">
                 {{item.email}}
               </div>
            </div>
         </div>
         <img :src="item.headImg" alt="" class="team-right">
       </div>
       <!-- <div class="team-item" @click="getUserPhoneInfo2()">
         <div class="team-left">
            <div class="p1">
              <span>刘 道臣</span>
            </div>
            <div class="p2">主任 / 创始合伙人</div>
            <div class="team-phone">
               <div>
                 <img src="../../../assets/images/phone.png" alt="">
                 13466762108
               </div>
               <div>
                 <img src="../../../assets/images/web.png" alt="">
                 ldc@easytimesip.com
               </div>
            </div>
         </div>
         <div class="team-right">

         </div>
       </div> -->
    </div>
    <div class="teamPhone-box wow bounceInRight animated" style="margin-bottom:30px">
      <div class="teamPhone-item"
      @click="getUserPhoneInfo(item.id)"
       v-for="item of chList" :key="item.id"
      >
         <div class="teamPhone-left">
            <div class="teamPhone-p1">
             <span v-if="lange=='ch'">{{item.cnName?item.cnName.substring(0,1)+' '+item.cnName.substring(1):''}}</span>
              <span v-if="lange=='en'">{{item.enName}}</span>
            </div>
            <div class="teamPhone-p2"  v-if="lange=='ch'">{{item.cnDuties}}</div>
            <div class="teamPhone-p2"  v-if="lange=='en'">{{item.enDuties}}</div>
            <div class="teamPhone-phone">
               <div style="margin-bottom:2px">
                 <img src="../../../assets/images/phone.png" alt="">
                  {{item.phoneNum}}
               </div>
               <div>
                 <img src="../../../assets/images/web.png" alt="">
                  <spans style=" overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;">{{item.email}}</spans>
               </div>
            </div>
         </div>
         <div class="teamPhone-right">
           <img :src="item.headImg" alt="">
         </div>
     </div>
     <!-- <div class="teamPhone-item"
      @click="getUserPhoneInfo1()">
         <div class="teamPhone-left">
            <div class="teamPhone-p1">
             <span>刘 道臣</span>
            </div>
            <div class="teamPhone-p2">
              主任 / 创始合伙人
            </div>
            <div class="teamPhone-phone">
               <div style="margin-bottom:2px">
                 <img src="../../../assets/images/phone.png" alt="">
                 13466762108
               </div>
               <div>
                 <img src="../../../assets/images/web.png" alt="">
                 ldc@easytimesip.com
               </div>
            </div>
         </div>
         <div class="teamPhone-right">
           <img src="../../../assets/images/ldc.png" alt="">
         </div>
     </div> -->
    </div>
    <!-- <div class="wow bounceIn animated ywzs_title" data-wow-offset="10"
    >
      <span>
        <img class="ywzs_img1" src="@/assets/images/yw_ico_1.png" />
        {{ lange == "ch" ? "国际团队" : "International team" }}
        <img class="ywzs_img2" src="@/assets/images/yw_ico_1.png" />
      </span>
    </div> -->
    <!-- <div class="wow bounceIn animated ywzs_title" data-wow-offset="10"
     v-if="enList.length!=0"
    >
      <span>
        <img class="ywzs_img1" src="@/assets/images/yw_ico_1.png" />
        {{ lange == "ch" ? "国际团队" : "International team" }}
        <img class="ywzs_img2" src="@/assets/images/yw_ico_1.png" />
      </span>
    </div> -->
     <!-- :lock-scroll="false" -->
    <!-- phone-dialog -->
     <!-- <el-dialog
      :header="false"
      :visible.sync="dialogPhoneVisible"
      :show-close	="false"
      width="90%"
      :modal-append-to-body="false"
      custom-class="teamPhoneDialog"
      >
      <div class="teamPhone-right1">
           <img :src="userInfo.headImg" alt="">
      </div>
      <div class="p1">
              <span v-if="lange=='ch'">{{userInfo.cnName}}</span>
              <span v-if="lange=='en'">{{userInfo.enName}}</span>
              <span v-if="lange=='ch'">{{userInfo.cnTitle}}</span>
              <span v-if="lange=='en'">{{userInfo.enTitle}}</span>
      </div>
      <div style="
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #01182C;padding-top:10px;margin-bottom:10px;font-size:12px;
         max-width:60%;
        ">
        <div class="p2"  v-if="lange=='ch'">{{userInfo.cnDuties}}</div>
        <div class="p2"  v-if="lange=='en'">{{userInfo.enDuties}}</div>
      </div>
      <div class="phone-box1">
        <div style="margin-bottom:4px">
          <img src="../../../assets/images/phone.png" alt="">
          {{userInfo.phoneNum}}
        </div>
        <div>
           <img src="../../../assets/images/web.png" alt="">
          {{userInfo.email}}
        </div>
      </div>
      <img src="../../../assets/images/yewujieshao.png" alt=""
      style="width:80px;height:25px;margin-bottom:5px;"
      >
      <div style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
        line-height:21px;
        "
      >
        {{lange=='ch'? userInfo.cnIntroduction:userInfo.enIntroduction}}
      </div>
      <img src="../../../assets/images/zhuanyelingyu.png" alt=""
      style="width:80px;height:25px;margin-bottom:5px;padding-top:10px"
      >
      <div  style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
        line-height:21px;
        ">
        {{lange=='ch'? userInfo.cnProfessional:userInfo.enProfessional}}
      </div>
      <img src="../../../assets/images/shehuihuodong.png" alt=""
        style="width:125px;height:25px;margin-bottom:5px;padding-top:10px"
       >
       <div  style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
       line-height:21px;
        ">
          {{lange=='ch'? userInfo.cnHonor:userInfo.enHonor}}
      </div>
    </el-dialog> -->
     <!-- <el-dialog
      :header="false"
      :visible.sync="dialogPhoneVisible"
      :show-close	="false"
      width="90%"
      :modal-append-to-body="false"
      custom-class="teamPhoneDialog"
      >
      <div class="teamPhone-right1">
           <img :src="userInfo.headImg" alt="">
      </div>
      <div class="p1">
              <span v-if="lange=='ch'">{{userInfo.cnName}}</span>
              <span v-if="lange=='en'">{{userInfo.enName}}</span>
              <span v-if="lange=='ch'">{{userInfo.cnTitle}}</span>
              <span v-if="lange=='en'">{{userInfo.enTitle}}</span>
      </div>
      <div style="
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #01182C;padding-top:10px;margin-bottom:10px;font-size:12px;
         max-width:60%;
        ">
        <div class="p2"  v-if="lange=='ch'">{{userInfo.cnDuties}}</div>
        <div class="p2"  v-if="lange=='en'">{{userInfo.enDuties}}</div>
      </div>
      <div class="phone-box1">
        <div style="margin-bottom:4px">
          <img src="../../../assets/images/phone.png" alt="">
          {{userInfo.phoneNum}}
        </div>
        <div>
           <img src="../../../assets/images/web.png" alt="">
          {{userInfo.email}}
        </div>
      </div>
      <img src="../../../assets/images/yewujieshao.png" alt=""
      style="width:80px;height:25px;margin-bottom:5px;"
      >
      <div style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
        line-height:21px;
        "
      >
        {{lange=='ch'? userInfo.cnIntroduction:userInfo.enIntroduction}}
      </div>
      <img src="../../../assets/images/zhuanyelingyu.png" alt=""
      style="width:80px;height:25px;margin-bottom:5px;padding-top:10px"
      >
      <div  style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
        line-height:21px;
        ">
        {{lange=='ch'? userInfo.cnProfessional:userInfo.enProfessional}}
      </div>
      <img src="../../../assets/images/shehuihuodong.png" alt=""
        style="width:125px;height:25px;margin-bottom:5px;padding-top:10px"
       >
       <div  style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
       line-height:21px;
        ">
          {{lange=='ch'? userInfo.cnHonor:userInfo.enHonor}}
      </div>
    </el-dialog> -->
       <el-dialog
      :header="false"
      :visible.sync="dialogPhoneVisible"
      :show-close	="false"
      width="90%"
      :modal-append-to-body="false"
      custom-class="teamPhoneDialog"
      >
      <div class="teamPhone-right1">
           <img :src="userInfo.headImg" alt="">
      </div>
      <div class="p1">
         <span v-if="lange=='ch'">{{userInfo.cnName?userInfo.cnName.substring(0,1)+' '+userInfo.cnName.substring(1):''}}</span>
         <span v-if="lange=='en'">{{userInfo.enName}}</span>
      </div>
      <div style="
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #01182C;padding-top:5px;margin-bottom:15px;font-size:12px;
         max-width:60%;
        ">
        <div class="p2"><div class="p2"  v-if="lange=='ch'">{{userInfo.cnDuties}}</div>
        <div class="p2"  v-if="lange=='en'">{{userInfo.enDuties}}</div></div>
      </div>
      <div class="phone-box1">
        <div style="margin-bottom:4px">
          <img src="../../../assets/images/phone1.png" alt="">
          {{userInfo.phoneNum}}
        </div>
        <div>
           <img src="../../../assets/images/web1.png" alt="">
          {{userInfo.email}}
        </div>
      </div>
      <div style="
        padding:0 15px;
        display: inline-block;
        white-space: nowrap;
        height:24px;
        text-align:center;line-height:25px;
        margin-bottom:10px;color:#fff;
        background:rgba(185, 167, 129, 1);
        border-radius:5px"
      >
         {{lange=='ch'? '业绩介绍':'Experience'}}
      </div>
      <div style="
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
        line-height:21px;
        font-size:12px;
        "
      >
      {{lange=='ch'? userInfo.cnIntroduction:userInfo.enIntroduction}}
      </div>
      <div style="
        padding:0 15px;
        display: inline-block;
        white-space: nowrap;
        height:25px;
        margin-bottom:10px;margin-top:10px;
        text-align:center;line-height:25px;color:#fff;
        background:rgba(185, 167, 129, 1);
        border-radius:5px"
      >
        {{lange=='ch'? "专业领域":"Practicing Areas"}}
      </div>
      <div  style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
        line-height:21px;
        font-size:12px;
        ">
        {{lange=='ch'? userInfo.cnProfessional:userInfo.enProfessional}}
      </div>
        <div style="
        padding:0 15px;
        display: inline-block;
        white-space: nowrap;
        height:24px;
        margin-bottom:10px;margin-top:10px;
        text-align:center;line-height:25px;color:#fff;
        background:rgba(185, 167, 129, 1);
        border-radius:5px"
      >
        {{lange=='ch'? '社会活动及荣誉':'Social Activities'}}
      </div>
       <div  style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
       line-height:21px;
       font-size:12px;
        ">
           {{lange=='ch'? userInfo.cnHonor:userInfo.enHonor}}
      </div>
    </el-dialog>
     <el-dialog
      :header="false"
      :visible.sync="dialogVisible"
      :show-close	="false"
      width="50%"
      :modal-append-to-body="false"
      custom-class="teamDialog"
      >
      <div class="team-right1">
           <img :src="userInfo.headImg" alt="">
            <!-- <img src="../../../assets/images/ldc.png" alt=""> -->
      </div>
      <div class="p1">
           <!-- <span>刘 道臣</span> -->
              <span v-if="lange=='ch'">{{userInfo.cnName?userInfo.cnName.substring(0,1)+' '+userInfo.cnName.substring(1):''}}</span>
              <span v-if="lange=='en'">{{userInfo.enName}}</span>
      </div>
      <div style="
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #01182C;padding-top:2px;margin-bottom:30px;font-size:14px;
         max-width:60%;
        ">
        <div class="p2">
          <div class="p2"  v-if="lange=='ch'">{{userInfo.cnDuties}}</div>
          <div class="p2"  v-if="lange=='en'">{{userInfo.enDuties}}</div>
        </div>
      </div>
      <div class="phone-box1">
        <div style="margin-bottom:8px">
          <img src="../../../assets/images/phone1.png" alt="">
          {{userInfo.phoneNum}}
        </div>
        <div>
           <img src="../../../assets/images/web1.png" alt="">
          {{userInfo.email}}
        </div>
      </div>
      <!-- <img src="../../../assets/images/yewujieshao.png" alt=""
      style="width:80px;height:25px;margin-bottom:10px;"
      > -->
      <div style="
        padding:0 15px;
        display: inline-block;
        white-space: nowrap;
        height:24px;
        text-align:center;
        line-height:25px;
        margin-bottom:10px;color:#fff;
        background:rgba(185, 167, 129, 1);
        border-radius:5px;
        "
      >
        {{lange=='ch'? '业绩介绍':'Experience'}}
      </div>
      <div style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
        line-height:21px;
        "
      >
         {{lange=='ch'? userInfo.cnIntroduction:userInfo.enIntroduction}}
         <!-- 刘道臣律师，北京艺识代律师事务所创始合伙人。早年毕业于山东大学与中国人民大学与香港大学。1995年开始律师执业，2002年开始专门从事知识产权维权律师业务，曾在多家知名律师事务所负责知识产权业务。历经近二十年的执业历程，在知识产权维权领域业绩突出，所代理的案件多次引起业内反响与关注，入选最高人民法院知识产权示范案例。近年来，刘道臣律师还积极活跃在涉知识产权国际仲裁领域，业绩突出。<br>
         刘道臣律师不仅是维权领域的“实战派”，同时也积极从事理论和学术活动，著有（合）《中国专利侵权赔偿第1案》一书，发表多篇专业论文，并长期担任中国人民大学法学院法律硕士论文校外评审专家。
         <br> 2019年，入选IPRdaily和知产力“优秀知识产权律师Top50“。 在代理大量案例基础上，刘道臣律师对包括司法保护和行政执法在内的知识产权维权体系、保密体系，数据安全有深入研究，多年来为多家平台和机构提供知识产权维权培训，展现了丰富的实践经验和深厚的理论素养，深受主办方的认可与好评。 -->
      </div>
      <div style="
        padding:0 15px;
        display: inline-block;
        white-space: nowrap;
        height:24px;
        margin-bottom:10px;margin-top:20px;
        text-align:center;line-height:25px;color:#fff;
        background:rgba(185, 167, 129, 1);
        border-radius:5px"
      >
        {{lange=='ch'? "专业领域":"Practicing Areas"}}
      </div>
      <div  style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
        line-height:21px;
        ">
        {{lange=='ch'? userInfo.cnProfessional:userInfo.enProfessional}}
      </div>
       <div style="
        padding:0 15px;
        display: inline-block;
        white-space: nowrap;
        height:24px;
        margin-bottom:10px;margin-top:20px;
        text-align:center;line-height:25px;color:#fff;
        background:rgba(185, 167, 129, 1);
        border-radius:5px"
      >
        {{lange=='ch'? '社会活动及荣誉':'Social Activities'}}
      </div>
       <div  style="font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #616161;
        width:95%;
        margin:0 auto;
       line-height:21px;
        ">
          {{lange=='ch'? userInfo.cnHonor:userInfo.enHonor}}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList,selectMember } from "@/api/index";
export default {
  name: "NewsList",
  components: {},
  computed: {},
  data() {
    return {
      dialogVisible:false,
      dialogPhoneVisible:false,
      lange: this.$cookies.getCookie("language"),
      indexNav: 0,
      nav1: {
        ch: "选择您想浏览的话题",
        en: "Select the topic you want to browse",
      },
      NavList: [], //导航
      NewsList: [], //内容列表
      lookdetail: {
        ch: "查看详情",
        en: "View details",
      },
      numIndex: 3,
      bodyHeight: "",
      pageNum: 1,
      navId: "",
      loading: false,
      listLoading: false,
      chList:[],
      enList:[],
      userInfo:{}
    };
  },
  created() {
    var _this = this;
    //滚动条滚到顶部
    this.$BackTop();
    this.getList();
    this.$nextTick(() => {
      // _this.newsApiFunc(true); //导航
      _this.listenerFunction();
      //_this.newsListFunc(_this.navId); //列表
    });
  },
  mounted() {},
  beforeDestroy() {
    //移除监听滚动条事件
    document.removeEventListener("scroll", this.handleScroll, true); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    //获取律师信息
    getList(){
     getUserList().then((res) => {
      this.chList = res.data.map(item=>{
        if(item.category == 1){
          return item
        }
      })
      let arr = []
      res.data.forEach(item => {
        if(item.category==2){
          arr.push(item)
        }
      });
      this.enList =arr
     })
    },
    getUserInfo(id){
      selectMember(id).then(res=>{
        this.userInfo = {}
        if(res.code==0){
          this.userInfo  = res.data //赋值当前详细信息
          this.dialogVisible = true
        }
      })
    },
    getUserPhoneInfo(id){
      selectMember(id).then(res=>{
        this.userInfo = {}
        if(res.code==0){
          this.userInfo  = res.data //赋值当前详细信息
          this.dialogPhoneVisible = true
        }
      })
    },
    listenerFunction(e) {
      //滚动条事件
      document.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
    },
    handleScroll() {
      //滚动距离
      var _this = this;
      var bodyHeight =
        document.body.offsetHeight * 1 - window.innerHeight - 150; //不需要一定完全触底.
      //console.info("window.pageYOffset="+window.pageYOffset +"   bodyHeight = "+ bodyHeight);
      if (window.pageYOffset >= bodyHeight) {
        // _this.newsListFunc(_this.navId); //列表
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
#newsListBox{
  padding-top: 80px;
}
>>> .teamDialog {
 border-radius: 10px !important;
 padding: 15px 30px !important;
 margin-top: 5vh !important;
 overflow-y: auto;
 max-height: 90%;
 position: relative;
 min-width: 480px;
}
>>> .teamDialog .el-dialog__header {
  display: none;
}
>>> .teamDialog .p1{
  font-size: 24px;
  /* line-height: 115px; */
}
>>> .teamDialog span:nth-child(1){
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #01182C;
  display: inline-block;
}
>>> .teamDialog span:nth-child(2){
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: 400 !important;
  color: #01182C;
  margin-left: 15px;
  font-size: 22px;
}
>>> .teamDialog .phone-box1{
  max-width: 60%;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #C18D33;
  font-size: 14px;
  border-bottom:1px solid #E2E2E2;
  padding-bottom: 20px;
  margin-bottom: 30px;
}
>>> .teamDialog .el-dialog__body{
  /* display: none; */
  word-break: break-word !important;
}
/* 手机dialog */
>>> .teamPhoneDialog {
 border-radius: 10px !important;
 padding: 5px 10px;
 margin-top: 30% !important;
 overflow-y: auto;
 max-height: 60vh;
 position: relative;
}
>>> .teamPhoneDialog .el-dialog__header{
  display: none;
}
>>> .teamPhoneDialog .el-dialog__body{
  /* display: none; */
  padding: 15px 10px;
  word-break: break-word !important;
}
>>> .teamPhoneDialog .p1{
  font-size: 16px;
  /* line-height: 115px; */
}
>>> .teamPhoneDialog span:nth-child(1){
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #01182C;
  display: inline-block;
}
>>> .teamPhoneDialog span:nth-child(2){
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: 400 !important;
  color: #01182C;
  margin-left: 5px !important;
}
.teamPhone-right1{
  width: 120px;
  height: 120px;
  position: absolute;
  top:3%;
  right:3%;
  border-radius: 10px;
}
.teamPhone-right1 img{
  width: 100% !important;
  height: 100% !important;
  border-radius: 10px;
}
>>> .teamPhoneDialog .phone-box1{
  display: flex;
  max-width: 60%;
  justify-content:space-between;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #C18D33;
  font-size: 12px;
  border-bottom:1px solid #E2E2E2;
  padding-bottom:10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
>>> .teamPhoneDialog .phone-box1 img{
  width: 12px;
  height: 12px;
}
.teamPhone-right1 img{
  width: 110px;
  height: 110px;
}
.phone-box1 div{
  min-width:110px;
}
.team-right1{
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  position: absolute;
  border-radius: 10px;
  top:4%;
  right:8%;
}
.team-right1 img{
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.phone-box1 img{
  width: 14px;
  height:14px;
}
.btnClass{
  background: #F7F9FD;
  box-shadow: 5px 0px 10px 0px rgba(152.942,156,154.475,1);
  border-radius: 9px 9px 9px 10px;
  text-align: center;
}
.team-box{
  width: 64%;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  flex-wrap: wrap;
}
.team-box .team-item{
  width: 48%;
  height: 190px;
  background: #BCA77C;
  /* box-shadow: 2px 0px 10px 0px rgb(216, 217, 216);
  border-radius: 9px 9px 9px 10px; */
  border-radius: 10px;
  display: flex;
  padding: 20px 30px;
  /* padding-left: 45px;
  padding-right: 60px; */
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  min-width: 415px;
  position: relative;
}
.team-left{
  /* width: 55%; */
}
.team-left .p1{
  font-size: 24px;
  /* line-height: 115px; */
}
.p1 span:nth-child(1){
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #01182C;
  display: inline-block;
}
.p1 span:nth-child(2){
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: 400 !important;
  color: #01182C;
  margin-left: 10px;
  font-size: 22px;
}
.team-left .p2{
  font-size: 14px;
  font-weight: 400;
  color: #01182C;
  margin-bottom: 15px;
  padding-top: 0px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #01182C;
}
.team-left .team-phone{
  width: 100%;
  padding-top: 15px;
  border-top: 1px solid #E2E2E2;
  font-size: 12px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 550;
  color: #01182C;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
}
.team-left .team-phone div:nth-child(1){
  margin-bottom: 5px;
}
.team-phone img{
  width: 12px;
  height: 12px;
  margin-right: 5px;
}
.team-right{
  width: 190px;
  background: url('../../../assets/images/ldc.png');
  background-repeat:no-repeat;
  background-size: contain;
  position: absolute;
  top: 0px;
  right: 0px;
  height: 100%;
  margin: auto;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.ywzs_title {
  width: 100%;
  display: block;
  text-align: center;
  font-size: 40px;
  color: #07566c;
  padding: 40px 0 60px 0;
  font-family: shsm, shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.ywzs_title > span {
  display: inline-block;
  position: relative;
  padding: 0 30%;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.ywzs_img1,
.ywzs_img2 {
  width: 26%;
  height: 2px;
  display: block;
  position: absolute;
  top: 50%;
}
.ywzs_img1 {
  left: 0;
}
.ywzs_img2 {
  right: 0;
}
/* 移动端样式 */
.teamPhone-box{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.teamPhone-box .teamPhone-item{
  width: 40%;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  background: #BCA77C;
  border-radius: 10px;
  padding: 10px 15px;
  box-shadow: 1px 0px 5px 0px rgb(216, 217, 216);
  border-radius: 9px 9px 9px 10px;
  box-sizing: border-box;
  min-width: 287px;
  margin-bottom:20px;
  position: relative;
}
.teamPhone-item .teamPhone-p1{
  font-size: 14px;
}
.teamPhone-p1 span:nth-child(1){
  /* text-align-last: justify; */
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #01182C;
  display: inline-block;
}
.teamPhone-p1 span:nth-child(2){
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: 400 !important;
  color: #01182C;
  margin-left: 5px;
}
.teamPhone-p2{
  font-size: 10px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #01182C;
  margin-bottom:5px;
  padding-top:4px;
  max-width: 145px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.teamPhone-phone{
  width: 100%;
  padding-top: 5px;
  border-top: 1px solid #E2E2E2;
  font-size: 10px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #01182C;
  padding-top: 10px;
}
.teamPhone-phone div{
  display: flex;
  align-items: center;
  height: 18px;
  max-width:145px;
}
.teamPhone-phone img{
  width: 12px;
  height: 12px;
  margin-right: 5px;
}
.teamPhone-right{
  width: 110.6px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
.teamPhone-right img{
 width: 100%;
 height: 100%;
 border-bottom-right-radius: 10px;
 border-top-right-radius: 10px;
}
/* 移动端样式 */
/* 我的结束 */
.box_n {
  width: 100%;
  display: block;
  position: relative;
}
@media only screen and (max-width: 1920px) {
  .team-box {
    display: flex;
  }
  .teamPhone-box{
    display: none;
  }
}
@media only screen and (max-width: 425px) {
  .team-box{
    display: none;
  }
  .teamPhone-box{
    display: flex;
  }
  .teamPhone-box{
    flex-wrap: wrap;
  }
 #newsListBox{
  padding-top: 30px;
 }
}
</style>



// WEBPACK FOOTER //
// src/views/TeamIntroduction/component/NewsList.vue